module.exports = __webpack_public_path__ + "img/kedit.226b1f1b.png";